import http from './http';

export const baseUrl = process.env.VUE_APP_URL;


export const SUCCESS_CODE = 20000;
export const CMD_SUCCESS_CODE = 20005;
export const LOGIN_SUCCESS = 20001;
export const FAILED_CODE = 50000;


//解析token
export const checkToken = () => {
    return http.requestGet(baseUrl + '/uc/token');
};
//退出登录
export const doLogout = () => {
    return http.requestGet(baseUrl + '/uc/sign-out');
};

//发送验证码
export const sendSmsCode = (account) => {
    return http.requestGet(baseUrl + '/uc/code', {
        params: {
            account: account,
            type: 'login'
        }
    });
};

//手机号短信登录/注册
export const smsLogin = (phone, smsCode) => {
    return http.requestPost(baseUrl + '/uc/phone/sms-login', {
        phone: phone,
        smsCode: smsCode
    });
};

// 上传服饰图片
export const uploadClothesImage = (formData) => {
    return http.requestPost(baseUrl + '/res/image/clothes', formData, {
        headers: {'Content-Type': 'multipart/form-data'}
    });
};

// 使用兑换码
export const useRedeemCode = (code) => {
    return http.requestPost(baseUrl + '/ai/cv/redeem/use?code=' + code);
};

// 查询我的兑换记录
export const listMyRedeemRecord = (page = 1, size = 20) => {
    return http.requestGet(baseUrl + '/ai/cv/redeem/list', {
        params: {page, size}
    });
};

// 查询当前用户配额统计
export const getQuotaSummary = () => {
    return http.requestGet(baseUrl + '/ai/cv/quota/summary');
};

// 查询 CV 任务数量
export const getCvTaskCount = () => {
    return http.requestGet(baseUrl + '/ai/cv/task/count');
};

// 创建 CV 任务
export const createCvTask = (payload) => {
    return http.requestPost(baseUrl + '/ai/cv/task', payload);
};

// 获取 CV 任务列表
export const listCvTasks = (page = 1, size = 10) => {
    return http.requestGet(baseUrl + '/ai/cv/task/list', {
        params: {page, size}
    });
};

// 查询单个 CV 任务状态
export const getCvTaskStatus = (id) => {
    return http.requestGet(`${baseUrl}/ai/cv/task/${id}`);
};

// 删除 CV 任务
export const deleteCvTask = (id) => {
    return http.requestDelete(`${baseUrl}/ai/cv/task/${id}`);
};

// 上传头像
export const uploadAvatar = (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return http.requestPost(baseUrl + '/res/image?type=avatar', formData, {
        headers: {'Content-Type': 'multipart/form-data'}
    });
};

// 更新用户信息
export const updateUserInfo = (username) => {
    return http.requestPut(baseUrl + '/uc/userinfo?username=' + username);
};
